/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();





  $(document).on('click','.mobile-toogle-size',function(e) {
     $('.image-cont').removeClass('quick-active');
     $(this).closest('.image-cont').addClass('quick-active') 
  })

  
  $(document).on('click', function (e) {
      if ($(e.target).closest(".quick-add-cover").length === 0 && $(e.target).closest(".mobile-toogle-size").length === 0) {
          $('.image-cont').removeClass('quick-active');
      }
  });


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$('.announcement__text .annoucement_curr').each(function(e) {
  var curr = parseInt($(this).data('price'));
  var final_curr = parseFloat(Shopify.currency.rate) * curr;
  $(this).html(Shopify.formatMoney(final_curr, money_format));
  console.log('working...456')
})


document.addEventListener('shopify:section:load', (event) => {
  $('.announcement__text .annoucement_curr').each(function(e) {
    var curr = parseInt($(this).data('price'));
    var final_curr = parseFloat(Shopify.currency.rate) * curr;
    $(this).html(Shopify.formatMoney(final_curr, money_format));
    console.log('working...456')
  });
});